/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from "react"
import Grid from "../../../../../../components/Habitacional/core/Grid"
import * as S from "../FormDFI.Style"
import Tabs from "../../../../../../components/Habitacional/Tabs"
import AddressInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/AddressInput"
import CPFCommunicatorInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/CPFCommunicatorInput"
import CPFInsuredInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/CPFInsuredInput"
import CheckBoxCombo from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/CheckBoxCombo"
import SelectDegreeOfKinshipInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/SelectDegreeOfKinshipInput"
import NameContactInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/NameContactInput"
import EmailContactInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/EmailContactInput"
import PhoneNumberContactInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/PhoneNumberContactInput"
import NameCommunicatorInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/NameCommunicatorInput"
import SelectCauseIncidentInputDFI from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/SelectCauseIncidentInputDFI"
import IncidentDateInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/IncidentDateInput"
import PhoneNumberInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/PhoneNumberInput"
import EmailInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/EmailInput"
import SelectFeedBackInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/SelectFeedBackInput"
import MessageInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/MessageInput"
import Button from "../../../../../../components/Habitacional/core/Button"
import { handleScrollSmooth } from "../../../../../../components/Habitacional/CardActivateInsurance/CardActivateInsurance"
import ValueOfTheLossInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/ValueOfTheLossInput"

const FormStepOneCommunicatorDFI = ({ onNext, setActiveTabIdDataForContact }) => {
    const getTabItemsDataForContact = () => [
        {
            id: 1,
            mainTitleTab: "Não",
            content: "",
        },
        {
            id: 2,
            mainTitleTab: "Sim",
            content: (
                <Grid container spacingColumn={7.5} spacingRow={3}>
                    <Grid item md={6} lg={6} xl={6}>
                        <NameContactInput />
                    </Grid>
                    <Grid item md={6} lg={6} xl={6}>
                        <EmailContactInput />
                    </Grid>
                    <Grid item md={6} lg={6} xl={6}>
                        <PhoneNumberContactInput />
                    </Grid>
                </Grid>
            ),
        },
    ];

    return (
        <S.ContentFormDFI>
            <Grid container spacingColumn={7.5} spacingRow={3}>
                <Grid item md={6} lg={6} xl={6}>
                    <NameCommunicatorInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <SelectDegreeOfKinshipInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <CPFCommunicatorInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <CPFInsuredInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <SelectCauseIncidentInputDFI />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <IncidentDateInput/>
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <PhoneNumberInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <EmailInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <AddressInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <SelectFeedBackInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <ValueOfTheLossInput />
                </Grid>
            </Grid>
            <MessageInput />
            <S.TitleForm>Quer informar outros dados para contato?</S.TitleForm>
            <Tabs forForms tabContentItem={getTabItemsDataForContact()} onTabChange={setActiveTabIdDataForContact} />
            <S.TextError>* Campos obrigatórios</S.TextError>
            <CheckBoxCombo />
            <S.ContentButton>
                <Button onClick={() => {onNext(); handleScrollSmooth()}} variant="primary" type="button" >Seguir</Button>
            </S.ContentButton>
        </S.ContentFormDFI>
    )
}

export default FormStepOneCommunicatorDFI